<div class="pb-4 border-b border-gray-200 flex justify-between">
	<div class="flex gap-4 items-center">
		<i-tabler name="alert-triangle" class="text-amber-500 h-8 w-8" />
		<h2 class="h2 mb-0">Are you sure?</h2>
	</div>
	<ui-button
		preset="ICON_DEFAULT"
		icon="x"
		(click)="onCancel()"
		[testHook]="testHooks.Button"
	/>
</div>
<div class="py-8">
	<p class="p">
		It looks like you have a cash {{ context }} of
		{{ math.abs(amount) | centsToDollars }} would you like to continue?
	</p>
</div>
<div class="flex justify-end gap-4 pt-4 border-t border-gray-200">
	<ui-button
		preset="EXTRA_LOW_EMPHASIS"
		(click)="onCancel()"
		label="Cancel"
		[testHook]="testHooks.CancelButton"
	/>
	<ui-button
		preset="HIGH_EMPHASIS"
		(click)="onContinue()"
		label="Continue"
		[testHook]="testHooks.ContinueButton"
	/>
</div>
